"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.symbolRegex = exports.separatorRegex = exports.dateRegexes = exports.blockSizeRegex = void 0;
// regex.ts
const symbolRegex = exports.symbolRegex = /[~!@#$%^&*(){}\[\]|_=\-\+\\\/:;"',.?]/g;
const separatorRegex = exports.separatorRegex = /[\da-zA-Z\n|]/g;
const blockSizeRegex = exports.blockSizeRegex = /[^\da-zA-Z\n|]/g;
const dateRegexes = exports.dateRegexes = {
  MM_DD_YYYY: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
  DD_MM_YYYY: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
  DD_MM_YY: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{2}$/,
  MM_DD_YY: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{2}$/,
  MONTH_DD_YYYY: /^(January|February|March|April|May|June|July|August|September|October|November|December) (\d{1,2}), (\d{4})$/,
  WEEKDAY_MONTH_DD_YYYY: /^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday), (January|February|March|April|May|June|July|August|September|October|November|December) (\d{1,2}), (\d{4})$/,
  DD_MMM_YYYY: /^(0[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{4})$/
};